import { lazy } from 'react';
import { loadFederatedModule } from '../../utils/loadFederatedModule';

export const CreateKpiSidePanel = lazy(
  async () => loadFederatedModule('KPI/CreateKpiSidePanel'),
);

export const ViewKpiSidePanel = lazy(
  async () => loadFederatedModule('KPI/ViewKpiSidePanel'),
);

export const KpiUpdatesDialog = lazy(
  async () => loadFederatedModule('KPI/KpiUpdatesDialog'),
);

export const KpiList = lazy(
  async () => loadFederatedModule('KPI/KpiList'),
);

export const Notification = lazy(
  async () => loadFederatedModule('KPI/Notification'),
);

export const KpiFiltersButton = lazy(
  async () => loadFederatedModule('KPI/KpiFiltersButton'),
);

export const KpiFiltersPopover = lazy(
  async () => loadFederatedModule('KPI/KpiFiltersPopover'),
);